import { FC, useEffect, useState } from 'react';
import './ModalAccessProfilesInsert.scss';
import ModalDefault from '../../../../components/ModalDefault/ModalDefault';
import { yupResolver } from '@hookform/resolvers/yup';
import { useAuth } from '../../../../providers/AuthProvider';
import { useForm } from 'react-hook-form';
import { toast } from 'react-toastify';
import { Col, FormGroup, Row } from 'react-bootstrap';
import ErrorMessage from '../../../../components/ErrorMessage/ErrorMessage';
import { schema } from './Validate';
import { useExample } from '../../../../providers/ExampleProvider';
import { useAccessProfile } from '../../../../providers/Access/AccessProfile/AccessProfileProvider';
import { AccessProfileModel } from '../../../../models/Access/AccessProfile/AccessProfileModel';

interface ModalAccessProfilesInsertProps {
  show: boolean;
  onClose: () => void;
}

type FormValues = {
  id?: number;
  name?: string;
}

const ModalAccessProfilesInsert: FC<ModalAccessProfilesInsertProps> = ({ show, onClose }) => {
  const [isLoadingSubmit, setIsLoadingSubmit] = useState<boolean>(false);

  const { accessProfile, setAccessProfile, setError, handleList, handleFetch } = useAccessProfile();
  const { onInvalid } = useAuth();

  const { handleSubmit, register, setValue, reset, formState: { errors } } = useForm({
    mode: "onChange",
    resolver: yupResolver(schema),
  });

  const handleClose = () => {
    setError('');
    setAccessProfile({});
    onClose();
  }

  const onSubmit = async (data: any) => {
    setIsLoadingSubmit(true);
    setError('');

    const ret = await handleFetch(data as AccessProfileModel);

    if (ret) {
      toast.success('Nível de Acesso salvo com sucesso!');
      handleList();
      onClose();
    }

    setIsLoadingSubmit(false);
  }

  useEffect(() => {
    if (show) {
      if (!!accessProfile?.id) {
        reset(accessProfile as FormValues);
      } else {
        reset(new AccessProfileModel());
        setAccessProfile({});
      }
    }
  }, [show]);

  return (
    <ModalDefault
      title={!!accessProfile?.id ? 'Editar Nível de Acesso' : 'Adicionar Nível de Acesso'}
      show={show}
      onClose={handleClose}
      sizeModal={'md'}
      showFooter={true}
      buttonText={isLoadingSubmit ? 'Salvando...' : 'Salvar'}
      showButtonSpinner={isLoadingSubmit}
      disabledSubmit={isLoadingSubmit}
      handleSubmit={handleSubmit(onSubmit)}
      backdrop="static"
      backgroundColor="#f8f9fa"
    >
      <div className="ModalAccessProfilesInsert" data-testid="ModalAccessProfilesInsert">
        <Row>
          <Col md={12}>
            <FormGroup className="form-group">
              <label htmlFor="name">NOME *</label>
              <input
                className={`form-control ${onInvalid(errors?.name)}`}
                type='text'
                {...register('name')}
                onChange={(e: any) => setAccessProfile({ ...accessProfile, name: e?.target?.value })}
              />
              <ErrorMessage name={'Nome'} type={errors?.name?.type?.toString()} min={3} max={50} />
            </FormGroup>
          </Col>
        </Row>
        <Row>
          <Col md={12}>
            <FormGroup className="form-group">
              <label htmlFor="description">DESCRIÇÃO *</label>
              <textarea
                className={`form-control ${onInvalid(errors?.description)}`}
                rows={5}
                {...register('description')}
                onChange={(e: any) => setAccessProfile({ ...accessProfile, description: e?.target?.value })}
              ></textarea>
              <ErrorMessage name={'Descrição'} type={errors?.description?.type?.toString()} min={3} max={255} />
            </FormGroup>
          </Col>
        </Row>
      </div>
    </ModalDefault>
  );
}

export default ModalAccessProfilesInsert;
